import React from 'react';
import { Link } from 'react-router-dom';
import { getFormData } from '../../common';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class MountainPeakList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mountainPeaks: [],
      mountains: [],
      mountainPeakCreateModalOpen: false
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    this.everestRepository.searchMountainPeak({}, (data) => {
      this.setState({ mountainPeaks: data.content });
    });
  }

  onClickCreate(e) {
    e.preventDefault();
    this.everestRepository.searchMountain({}, (data) => {
      this.setState({ mountains: data.content });
    });
    this.showMountainPeakCreateModal();
  }

  onCancelCreate(e) {
    e.preventDefault();
    this.hideMountainPeakCreateModal();
  }

  onSubmitCreate(e) {
    e.preventDefault();
    const formData = getFormData(e.target);
    this.everestRepository.createMountainPeak(formData, () => {
      window.Toast.info("Completed!");
      this.hideMountainPeakCreateModal();
      this.everestRepository.searchMountainPeak({}, (data) => {
        this.setState({ mountainPeaks: data.content });
      });
    });
  }

  showMountainPeakCreateModal() {
    this.setState({ mountainPeakCreateModalOpen: true });
    window.$ && window.$("#mountain-peak-create-modal").modal("show");
  }

  hideMountainPeakCreateModal() {
    this.setState({ mountainPeakCreateModalOpen: false });
    window.$ && window.$("#mountain-peak-create-modal").modal("hide");
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />

        <br />
        <div className={"container"} style={{ textAlign: "initial" }}>
          <div className={"row"}>
            <button className={"btn btn-primary btn-sm"} onClick={this.onClickCreate.bind(this)}>+ 추가</button>
          </div>
        </div>

        <br />
        <div className={"container"}>
          <div className={"row"}>
            <table className={"table table-center table-middle"}>
              <colgroup>
                <col width="20%"></col>
                <col width="20%"></col>
                <col width="20%"></col>
                <col width="20%"></col>
                <col width="20%"></col>
              </colgroup>
              <thead>
                <tr>
                  <th>이름</th>
                  <th>높이(m)</th>
                  <th>위도</th>
                  <th>경도</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.mountainPeaks.map((item) => (
                  <tr key={item.id}>
                    <td style={{ textAlign: "left" }}>
                      <Link to={"/everest-admin/mountain-peak/" + item.id}
                        className={`title ${item.peakDeleted ? "deleted" : ""}`}>{item.mountainName} {item.peakName}</Link>
                    </td>
                    <td>{item.height}</td>
                    <td>{item.latitude}</td>
                    <td>{item.longitude}</td>
                    <td>{item.represent ? "주봉" : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <MountainPeakCreateModal
          componentId={"mountain-peak-create-modal"}
          open={this.state.mountainPeakCreateModalOpen}
          mountains={this.state.mountains || []}
          onCancel={this.onCancelCreate.bind(this)}
          onSubmit={this.onSubmitCreate.bind(this)} />
      </React.Fragment>
    );
  }
}

class MountainPeakCreateModal extends React.Component {
  render() {
    return (
      <div className="modal" tabIndex="-1" id={this.props.componentId}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {this.props.open && (
              <form onSubmit={this.props.onSubmit}>
                <div className="modal-header border-0">
                  <h5 className="modal-title">&nbsp;</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body" style={{ textAlign: "initial" }}>
                  <div className={"form-group"}>
                    <label>Mountain</label>
                    <select className={"form-control"} name={"mountainId"}>
                      {this.props.mountains.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}{item.deleted ? " <-- 삭제" : ""}</option>
                      ))}
                    </select>
                  </div>
                  <div className={"form-group"}>
                    <label>Mountain Peak Name</label>
                    <input className={"form-control"} type={"text"} name={"name"} />
                  </div>
                  <div className={"form-group"}>
                    <label>Height</label>
                    <input className={"form-control"} type={"text"} name={"height"} />
                  </div>
                  <div className={"form-group"}>
                    <label>Latitude</label>
                    <input className={"form-control"} type={"text"} name={"latitude"} />
                  </div>
                  <div className={"form-group"}>
                    <label>Longitude</label>
                    <input className={"form-control"} type={"text"} name={"longitude"} />
                  </div>
                </div>
                <div className="modal-footer border-0">
                  <button className="btn btn-outline-secondary border-0" onClick={this.props.onCancel}>취소</button>
                  <button type="submit" className="btn btn-outline-primary border-0">생성</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export { MountainPeakList };
